// TODO: replace with backend feature flag
export const isLemonadeEnabled = () => localStorage.getItem('lemonade_enabled') === 'true';

export const isTimeCheckBannerEnabled = () =>
    localStorage.getItem('time_check_banner_enabled') === 'true';

// ===== DEV FLAGS =====

export const isIgnoreStrictModeEnabled = () => localStorage.getItem('ignoreStrictMode') === 'true';

export const isRequirePolyfillTimezonesTest = () =>
    localStorage.getItem('require_polyfill_timezones') === 'true';

export const isClassroomDebugLogsEnabled = () =>
    localStorage.getItem('new_classroom_debug_logs') === 'true';

export const isPresentationModeDebugLogsEnabled = () =>
    localStorage.getItem('presentation_mode_debug_logs') === 'true';
export const isPresentationPDFDebugLogsEnabled = () =>
    localStorage.getItem('presentation_pdf_debug_logs') === 'true';

export const isPermissionDebugLogsEnabled = () =>
    localStorage.getItem('permission_debug_logs') === 'true';

export const isMaskErrorsDisabled =
    localStorage.getItem('new_classroom_mask_errors_disabled') === 'true';

export const isClassroomDebugLabelsEnabled =
    localStorage.getItem('new_classroom_debug_labels') === 'true';

export const classroomPipDisabled = () => localStorage.getItem('classroom_pip_disabled') === 'true';

export const getTestStableAnyBrowserVersion = () => {
    try {
        const version = parseInt(localStorage.getItem('test_stable_any_browser_version') ?? '', 10);

        return isNaN(version) ? null : version;
    } catch {
        return null;
    }
};

export const isRoomsEnforced = () => localStorage.getItem('rooms_enforced') === 'true';

export const isRoomsDebugLogsEnabled = () => localStorage.getItem('rooms_debug_logs') === 'true';

export const isCommandLogEnabled = () => localStorage.getItem('command_debug_logs') === 'true';

export const isChatDebugLogsEnabled = () => localStorage.getItem('chat_debug_logs') === 'true';

export const getTestClassroomEndDate = () =>
    localStorage.getItem('new_classroom_test_class_end_date');

// we'll enable it at the end of 2024
export const isYearlyRecapEnabled = () => localStorage.getItem('yearly_recap_enabled') === 'true';

export const isDualVideoEnforced = () =>
    localStorage.getItem('new_classroom_dual_video_enforced') === 'true';

export const classroomBackgroundTypeEnforced = () => {
    const enforcedValue = localStorage.getItem('classroom_background_type_enforced');
    if (!enforcedValue) {
        return undefined;
    }

    return enforcedValue as 'virtual-background' | 'video-mask' | 'no-background-supported';
};

// Trick from Zoom Team. It makes window.zmClient available for debugging purposes.
export const isDevZoomClientAvailableInConsole = () =>
    localStorage.getItem('dev_zoom_client_available_in_console') === 'true';

export const isPermissionsQueryDisabled = () =>
    localStorage.getItem('disable_permissions_query') === 'true';

export const isReconciliateDevicesStateDisabled = () =>
    localStorage.getItem('disable_reconciliate_devices_state') === 'true';

export const devCheckVersionOnIdleTimeInSeconds = () => {
    const value = localStorage.getItem('dev_check_version_on_idle_time_in_seconds');

    if (!value) {
        return undefined;
    }

    const parsed = parseInt(value, 10);

    return isNaN(parsed) ? undefined : parsed;
};

/**
 * To be used on local development, should be a valid release ID (release-{number})
 */

export const devMockedLocalReleaseId = () => localStorage.getItem('dev_mocked_local_release_id');

/**
 * Override the Sentry DSN for the Classroom app with a production DSN.
 * Useful for testing that errors are correctly reported to Sentry without
 * exceeding the shared development quota.
 *
 * How to use:
 * 1. Get the production DSN from the production app console:
 *      lgConfig.sentryClassroomFeDsn
 * 2. In Chrome DevTools console, run:
 *      sessionStorage.setItem('classroom_sentry_dsn_overwrite', '<paste-production-dsn-here>')
 * 3. Refresh the page and open the Classroom app.
 * 4. Trigger an error (e.g. navigate to a broken route or throw manually).
 * 5. The error should appear in the Sentry dashboard under the production project.
 *
 * The overwrite is automatically cleared when the tab is closed (sessionStorage).
 */
export const getDevClassroomSentryDsnOverwrite = () =>
    sessionStorage.getItem('classroom_sentry_dsn_overwrite') || undefined;

export const devOmitSentryTunnel = () => localStorage.getItem('dev_omit_sentry_tunnel') === 'true';

export const getDevTldrawLicenceKey = () =>
    localStorage.getItem('dev_tldraw_licence_key') || undefined;

// Local emulation of Klass.isB2G for testing
export const isB2GClassEnforced = () =>
    localStorage.getItem('new_classroom_b2g_enforced') === 'true';
